<template>
    <div class="dml-category-info">
        <div class="dml-category-info__sort">
            <div class="dml-category-info__sort-title" v-on:click="showSort">
                <span class="dml-category-info__sort-text">Sortowanie:</span>
                <span class="dml-category-info__sort-value">
                    {{sortItems.current.label}}
                    <dm-icon class="dml-symbol dml-category-info__icon" name="angle-down" :width="16" :height="16" />
                </span>
            </div>
            <ul v-show="isSortExpanded"
                class="dml-category-info__sort-list list">
                <li class="dml-category-info__sort-list-element">
                    <dm-radio :name="sortItems.current.label" :isSelected="true" />
                </li>
                <dm-product-list-action v-for="sortItem in sortItems.items"
                                        :key="sortItem.label"
                                        :href="sortItem.url"
                                        :title="`Sortuj według ${sortItem.label}`">
                    <li data-ga="m_product_list.sort"
                        :data-ga-label="sortItem.label"
                        class="dml-category-info__sort-list-element">
                        <dm-radio :name="sortItem.label" />
                    </li>
                </dm-product-list-action>
            </ul>
        </div>
    </div>
</template>

<script>
    import ProductListAction from './product-list-action-component.vue';
    import IconComponent from '../shared/icon-component.vue';
    import RadioComponent from '../shared/radio-component.vue';

    export default {
        name: 'dm-category-info',
        components: {
            'dm-product-list-action': ProductListAction,
            'dm-icon': IconComponent,
            'dm-radio': RadioComponent
        },
        data: () => ({
            isSortExpanded: false,
        }),
        computed: {
            sortItems() {
                return this.$store.getters.sortItems;
            }
        },
        methods: {
            showSort() {
                this.isSortExpanded = true;
                this.$pageWrap.addEventListener('click', this.hideSort, true);
            },
            hideSort() {
                this.isSortExpanded = false;
                this.$pageWrap.removeEventListener('click', this.hideSort, true);
            }
        },
        mounted() {
            this.$pageWrap = document.querySelector('.js-page-wrap');
        }
    };
</script>
